import React, { createRef, useState, useEffect, useContext } from "react";
import "./MediaTab.scss";

import leftArrowIcon from "../../images/leftArrow.svg";
import Dropzone from "react-dropzone";
import ImageUpload from "../../images/drag_drop_image.svg";
import LargeImageUpload from "../../images/drag_drop_large_image.svg";
import Structure from "../../images/default_structure_new_icon.svg";
import StructureActive from "../../images/active-structure-new-icon.svg";
import ImageActive from "../../images/active_image_new_icon.svg";
import ImageIconDefault from "../../images/default_image_new_icon.svg";
import InActiveForm from "../../images/default_forms_new_icon.svg";
import InActiveExtraIcon from "../../images/default_devider_new_icon.svg";
import LeftIcon from "../../images/left_arrow_image_icon.svg";
import DeleteIcon from "../../images/DeleteNewIcon.svg";
import InActiveVideo from "../../images/Video_Inactive.svg";

import ValueContext from "../../utils/contextAPI/contextAPI";
import LibrarySearchIcon from "../../images/library-searchIcon.svg";
import ImageTabPreviewIcon from "../../images/imageTabPreviewIcon.svg";
import ImportDams from '../../images/import-dams-image.svg';
import LargeImportDams from '../../images/import-dams-large-image.svg';
import "react-toastify/dist/ReactToastify.css";

import { uploadAnImageDragAndDrop, getImageLists, deleteSharedFiles } from "../../services/apis";
import { Tabs, Tab } from "react-bootstrap";
import DAMSSearchModal from "./DAMSSearchModal";
import CustomModal from "../CustomModal";
import InfoIcon from '../../images/InfoIconGray.svg';
import PreviewImageTab from './PreviewImageTab';
import DeleteImageModal from "./DeleteImageModal/DeleteImageModal";
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";

// import { useTranslation } from "react-i18next";

function MediaTab(props) {
  //const { t } = useTranslation();
  const {setLoadSuccess} = props;
  const appData = useContext(ValueContext);

  const dropzoneRef = createRef();
  const [showErrToastUpload, setShowErrToastUpload] = useState(false);
  const [loadedImages, setLoadedImages] = useState({});
  const [imageURL, setImageURL] = useState([]);
  const [currentImageURL, setCurrentImageURL] = useState([]);
  const [showDAMSModel, setShowDAMSModel] = useState(false);
  const [query, setQuery] = useState("");
  const [localTabInput, setLocalTabInput] = useState("");
  const [linkUrl, setLinkUrl] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [sharedImageInputValue, setSharedImageInputValue] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteValue, setDeleteValue] = useState(null);

  const HideStructureBlock = () => {
    const hideStructureBlockgjs = document.querySelector(".gjs-block-categories .gjs-blocks-c");
    const showStructure = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c").firstChild;
    showStructure.getElementsByClassName("gjs-block__media")[0].firstChild.src = Structure;
    showStructure.classList.remove("active-block");
    hideStructureBlockgjs.classList.add("d-none");
    const hideForms = document.querySelector(".gjs-block-categories").lastChild;
    hideForms.classList.add("d-none");
    const showDefaultForm = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c").childNodes[7];
    // if(showDefaultForm){
    //   showDefaultForm.style.background = "white";
    //   showDefaultForm.getElementsByClassName("gjs-block__media")[0].firstChild.src = InActiveForm;
    //   showDefaultForm.classList.remove("active-block");
    // }
    const inActiveExtra = document?.querySelector(
      ".gjs-blocks-no-cat .gjs-blocks-c"
    )?.childNodes[8];
    // if (inActiveExtra) {
    //   inActiveExtra.getElementsByClassName(
    //     "gjs-block__media"
    //   )[0].lastChild.src = InActiveExtraIcon;
    //   inActiveExtra.classList.remove("active-block");
    // }
  }

  const FhowStructureBlock = () => {
    const hideStructureBlockgjs = document.querySelector(".gjs-block-categories .gjs-blocks-c");
    const showStructure = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c").firstChild;
    showStructure.getElementsByClassName("gjs-block__media")[0].firstChild.src = StructureActive;
    showStructure.classList.add("active-block");
    showStructure.getElementsByClassName("gjs-block__media")[0].firstChild.classList.add("img-block");
    hideStructureBlockgjs.classList.remove("d-none");

    const ImageBlock = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c").children[2];
    ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src = ImageIconDefault;
    ImageBlock.classList.remove("active-block");
  }

  const highlightImageIcon = () => {
    const hideStructureBlockgjs = document.querySelector(".gjs-block-categories .gjs-blocks-c");
    const ImageBlock = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c").children[2];
    ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src = ImageActive;
    ImageBlock.classList.add("active-block");
    // ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.classList.add("img-block");
  }


  useEffect(() => {
    props.setState(true);
    HideStructureBlock();
    highlightImageIcon();
    getImageLists((response, err, errorCode) => {
      if (err) {
        // const errCoponent = ErrComponentToRender(errorCode);
      } else {
        setLoadedImages(response?.data?.response);
        //props.setState(true);
      }
    });
    let imageURLList = window.localStorage.getItem("imageURL");
    setImageURL(imageURLList ? JSON.parse(imageURLList) : []);
  }, []);
  function isValidHttpUrl(string) {
    let url;
    if (imageURL.includes(string)) return "duplicate";
    if (
      [".JPG", ".PNG", ".JPEG", ".jpg", ".jpeg", ".png"].some((format) =>
        string.endsWith(format)
      )
    ) {
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }
    } else return false;

    return url.protocol === "http:" || url.protocol === "https:";
  }
  const handleChangeURL = (e) => {
    const value = e.target.value.replace(/\s+/g, "");
    setCurrentImageURL(value);
    setLinkUrl(value)
  };
  const submitImageURL = () => {
    let retValidation = isValidHttpUrl(currentImageURL);
    if (!retValidation) {
      showErrorToast('Invalid URL!.');
      return;
    }
    if (retValidation === "duplicate") {
      showErrorToast('Duplicate URL!');
      return;
    }
    setImageURL([...imageURL, currentImageURL]);
    window.localStorage.setItem(
      "imageURL",
      JSON.stringify([...imageURL, currentImageURL])
    );
    setLinkUrl("")
  };
  

  const fileValidation = (uploadFile) => {
    var allowedExtensions = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedExtensions.includes(uploadFile.type)) {
      showErrorToast('Please upload file having extensions .jpeg/.jpg/.png/ only.');
      return false;
    }
    return true;
  };
  const onDropImage = (accepted, rejected) => {
    if (Object.keys(rejected).length !== 0) {
      setShowErrToastUpload(true);
      setTimeout(() => {
        setShowErrToastUpload(false);
      }, 3000);
      // setTab1Value(2);
    } else {
      //let myRenamedFile = [];
      const formData = new FormData();
      let uploadImage = {
        name: ''
      };

      accepted.forEach((uploadFile) => {
        if (uploadFile.size > 5767168) {
          showErrorToast('Image upload failed, cannot upload image of size more than 500Kb.!');
          return;
        }
        if (!fileValidation(uploadFile)) return;
        formData.append("file", uploadFile);
        uploadImage.name = uploadFile.name;
        // formData.append("deckId", appData.deckId._id);
      });

      uploadAnImageDragAndDrop(formData, (response, err, errorCode) => {
        if (err) {
          // const errCoponent = ErrComponentToRender(errorCode);

          if (
            err.response?.data?.response?.errorCode === "ERR_EXCEED_MAX_UPLOAD_SIZE_500KB"
          ) {
          } else {
          }
        } else {
          getImageLists((response, err, errorCode) => {
              // console.log(response?.data?.response, 'response?.data?.response');
            if (err) {
              // const errCoponent = ErrComponentToRender(errorCode);
            } else {
              setLoadedImages(response?.data?.response);
              const findImage = response?.data?.response?.uploadedList?.find(img => img.includes(uploadImage?.name?.toLowerCase()));
              sendImage(findImage, 'click');
              showSuccessToast('Image uploaded successfully');
            }
          });
        }
      });
    }
  };

  const backButtonHandler = () => {
    document.querySelector(".custom-images").click();
    props.editor.AssetManager.close();
    props.setState(false);
  }

  const goToPrevTab = () => {
    props.setState(false);
    props.editor.AssetManager.close();
    props.hideStyleManger();
  };
   const parentComponent = props?.editor?.getSelected();

   const sendImage = (url, type, event) => {
    if(type === 'click') {
      let cmp = props?.editor?.getSelected();

      if (!cmp?.attributes?.src) {
        cmp &&
          cmp.addStyle({
            "background-image": `url("${url.imageProductionLink || url}")`,
          });
      } else if (cmp.attributes.src) {
        cmp && cmp.set({ src: url.imageProductionLink || url, alt: "ImageName" });
      }
      if(parentComponent?.attributes?.type === "image") {
        setTimeout(() => {
          const parentComponent = props.editor.getSelected();
          const style = parentComponent.getStyle();
          delete style.height;
          parentComponent.setStyle({
            ...style,
            height: "auto",
          });
        }, 10);
      }
    } else if (type === 'drag') {
      window.localStorage.setItem("drop",true)
      event.dataTransfer.setData('application/json', JSON.stringify(url));
      event.dataTransfer.effectAllowed = 'copy';
      event.dataTransfer.setDragImage(event.nativeEvent.srcElement, 0, 0);
    }
  };


  const handleImportDAMS = () => {
    setShowDAMSModel(true);
  };

  const removeSearchHandler = () => {
    setQuery("");
  };

  const searchInputHandler = (e, searchFrom) => {
    const value = e.target.value;
    if(searchFrom === "Local"){
      setLocalTabInput(value.split(" ").join(""))
    }else{
      setQuery(value.split(" ").join(""));
    }
    
  };

  const localTabDetails = (list) => {
    const localTabFileName = list.substring(list.lastIndexOf('/') + 1);
    return localTabFileName.substring(0, localTabFileName.lastIndexOf('.')).replace(/\s+/g, '_');
  }

  const localResults = loadedImages.uploadedList?.filter((li)=>localTabDetails(li).toLowerCase().includes(localTabInput?.toLowerCase()))
  const searchedResult = loadedImages.damsList?.filter((li) =>
    li.imageName.toLowerCase().includes(query.toLowerCase())
  );
  const sharedSearchedResult = appData?.deckId?.deck_shared_assets?.images?.filter((li) =>
    li?.name?.toLowerCase()?.includes(sharedImageInputValue.toLowerCase()));

  // const localTabDetails = loadedImages?.uploadedList?.
  

  const openPreviewImageTab = (loadImage) => {
    setModalData(loadImage);
    setIsModalOpen(true);
  }

  const openDeleteSharedImage = (value) => {
    setDeleteValue(value);
    setIsDeleteModalOpen(true);
  }

  const toastSuccesThrow = (msg) => {
    showSuccessToast(msg);
  }
  
  const toastErrorThrow = (msg)=>{
    showErrorToast(msg);
    }
  
  const deleteSharedImage = (type, value) => {
    if(type === "No") {
      setDeleteValue(null);
      setIsDeleteModalOpen(false);
    } else {
      const payloadObj = {list: deleteValue, deckId: appData.deckId._id}
      deleteSharedFiles(payloadObj, (response, err, ErrorCode)=>{
        if (err) {
            // setLoading(false);
            toastErrorThrow("Delete Unsuccessful");  
            setIsDeleteModalOpen(false);
        } else {
            // setLoading(false);

            //<--- delete image from list and editor
            const deletedData =  appData?.deckId?.deck_shared_assets?.images?.filter((file)=> file.name == deleteValue.name);
            const deletedImageNames = deletedData.map(item => item.name);

            props.editor.getWrapper().find('img').forEach(imgCmp => {
              const src = imgCmp.getAttributes().src;
              const fileName = src?.split('/').pop();

              if (deletedImageNames.includes(fileName)) {
                imgCmp.setAttributes({
                  src: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik0yLjI4IDNMMSA0LjI3bDIgMlYxOWMwIDEuMS45IDIgMiAyaDEyLjczbDIgMkwyMSAyMS43MiAyLjI4IDNtMi41NSAwTDIxIDE5LjE3VjVhMiAyIDAgMCAwLTItMkg0LjgzTTguNSAxMy41bDIuNSAzIDEtMS4yNUwxNC43MyAxOEg1bDMuNS00LjV6Ij48L3BhdGg+CiAgICAgIDwvc3ZnPg==',
                  alt: 'ImageName'
                });
                      //issue 2234 resolved - Gilead QA and UAT when a image is added in a trigger or in pop up its not showing in preview
                imgCmp.set({src:'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik0yLjI4IDNMMSA0LjI3bDIgMlYxOWMwIDEuMS45IDIgMiAyaDEyLjczbDIgMkwyMSAyMS43MiAyLjI4IDNtMi41NSAwTDIxIDE5LjE3VjVhMiAyIDAgMCAwLTItMkg0LjgzTTguNSAxMy41bDIuNSAzIDEtMS4yNUwxNC43MyAxOEg1bDMuNS00LjV6Ij48L3BhdGg+CiAgICAgIDwvc3ZnPg=='});
              }
            });
            //  <---
            let deck_shared_assets = appData?.deckId?.deck_shared_assets;
            const removed =  appData?.deckId?.deck_shared_assets?.images?.filter((file)=> file.name !== deleteValue.name);
            deck_shared_assets.images = removed;
            appData.setDeckId({ ...appData?.deckId, deck_shared_assets});
            // setSharedData(removed);
            toastSuccesThrow('Deleted Successfully');
            setIsDeleteModalOpen(false);
            // props.editor.select(null);
            // props.editor.render()
        }
      });
    }
  }

  return (
    <div className="dat-tab">
      <div className="properties-block">
        <div className="image_back_button">
          <div className="image_back_icon d-flex">
            <img src={LeftIcon} alt="" className="image-tab-back-button" onClick={backButtonHandler}/>
            <span className="image_back_text">
              <span className="image_back_text_bold">Image </span>
              <span className="image_bcak_text_normal">(Add/Import/Upload)</span>
            </span>
          </div>
        </div>
        <Tabs
          jsutify
          variant="link"
          defaultActiveKey="tab-1"
          className="mb-1 list-inline iamgeTabs imageTabs"
        >
          {/* <Tab
            className="iamgeTabs customScrollBar"
            eventKey="tab-1"
            title="Local"
          >
            <div className="dragDrop">
              <Dropzone
                ref={dropzoneRef}
                multiple={true}
                accept=".jpeg,.png,.jpg,.gif,.svg"
                onDrop={(accepted, rejected) => onDropImage(accepted, rejected)}
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()} className="presentation">
                    <input {...getInputProps()} />
                    <div className="row">
                      <div className="col-md-4 drag-drop-image">
                        <img src={ImageUpload} />
                      </div>
                      <div className="col-md-8 drag-drop-here">
                        Drag & drop image here
                        <br />
                        Or{" "}
                        <a className="browseLink" href="javascript:void(0)">
                          Click to browse
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            </div>
          </Tab> */}
           <Tab
             className="iamgeTabs customScrollBar imageTabContent"
             eventKey="tab-1"
             title={`Local`}
           >
             <div className="image-local-tab">
                <div className="dragDrop">
                  <Dropzone
                    ref={dropzoneRef}
                    multiple={true}
                    accept=".jpeg,.png,.jpg,.gif,.svg"
                    onDrop={(accepted, rejected) => onDropImage(accepted, rejected)}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div {...getRootProps()} className="">
                          <input {...getInputProps()} />
                          <div className="drag-drop-image">
                            <img src={props.expandLeft === 450 ? LargeImageUpload : ImageUpload} height={44}/>
                          </div> 
                      </div>
                    )}
                    </Dropzone>
                  <div className="drag-drop-here">
                    <img src={InfoIcon} alt="InfoIcon" width={8} height={8}/>
                    <p>Drag & drop or select to browser
                    (Max 5.0 MB)</p>
                  </div>
                </div>
                <div className="d-flex local-image-search">
                 <img
                   alt="search"
                   src={LibrarySearchIcon}
                   className="local-image-search-icon"
                 />
                 <input 
                   type="text"
                   name="searchInput"
                   placeholder="Search by name"
                   className="local-image-search-field"
                   //onChange={(e) => setLocalTabInput(e?.target?.value)}
                   onChange={(event)=> searchInputHandler(event, 'Local')}
                   autoComplete="off"
                   value={localTabInput}
                   // onKeyDown={handleOnEnter}
                   autoFocus
                   //  onKeyPress={handleEnterKeypress}
                 />
               </div>
              </div>
              <div className="uploadedImgScroll customScrollBar" style={{justifyContent:localResults?.length <1?'center':'', alignContent:localResults?.length <1?'center':''}}>
                {localResults?.map((loadImage, index) => (
                  <div className="row imageRow">
                    <div className="col-md-12">
                      <div className="thumbnail-image-content">
                        <img
                          src={loadImage}
                          alt=""
                          draggable="true"
                          className={`gjs-imagetest${Math.random()} img-fluid local-thumbnail-image`}
                          onClick={() => sendImage(loadImage, 'click')}
                          // onDragStart={(event) => {
                          //   const data = JSON.stringify(loadImage?.link);
                          //   event.dataTransfer.setData('application/json', data);
                          //   event.dataTransfer.effectAllowed = 'copy';
                          // }}
                          onDragStart={(event) => sendImage(loadImage, 'drag', event)}
                          // onDragEnd={() => sendImage(loadImage)}
                          style={{cursor: 'all-scroll'}}
                        ></img>
                        <div className="imageTabOverlay">
                          <img src={ImageTabPreviewIcon} alt="" className="image-tab-preview"/>
                          <p className="image-tab-preview-text" onClick={() => openPreviewImageTab(loadImage)}>Preview</p>
                        </div>
                      </div>
                      <div 
                        className={`image-tab-imageDetails`}>
                        <div 
                          className={`imageNameCss ${Object.keys(localTabDetails(loadImage)).length > 21 ? 
                          'image-tab-imageDetails-tooltip' : ''}`}
                          data-title={Object.keys(localTabDetails(loadImage)).length > 21 ? 
                          localTabDetails(loadImage): ""}
                          > {localTabDetails(loadImage)}</div> 
                        <div className="preview-image-thumbnail" onClick={() => openPreviewImageTab(loadImage)}>View</div>
                      </div>
                    </div>
                  </div>
                ))}
                {
                   loadedImages?.uploadedList?.length > 0 
                     ?  localResults?.length > 0 ? "" : 
                         <div className="not-found-message">
                           <img src={InfoIcon} width={7} height={8}/>
                           <p>No match found. Please try again.</p>
                         </div> 
                     : <div className="not-found-message">
                         <img src={InfoIcon} width={7} height={8}/>
                         <p>Please add images.</p>
                       </div>
	                 }
              </div>
            </Tab>
          {/* <Tab
            className="iamgeTabs customScrollBar"
            eventKey="tab"
            title={`DAMS`}
          >
            {" "}
            <div className="image-dams-tab">
              <div className="import-dams">
                <img src={props.expandLeft === 450 ? LargeImportDams : ImportDams} alt="" 
                  height={36} 
                  onClick={handleImportDAMS}
                  className="upload-dams-image"
                />
              </div>
              <div className="d-flex local-image-search">
                <img
                  alt="search"
                  src={LibrarySearchIcon}
                  className="local-image-search-icon"
                />
                <input 
                  type="text"
                  name="searchInput"
                  placeholder="Search by name"
                  className="local-image-search-field"
                  // onChange={(e) => handleChangesearchfields(e, "searchInput")}
                  autoComplete="off"
                  // onKeyDown={handleOnEnter}
                  //onChange={searchInputHandler}
                  onChange={(event)=> searchInputHandler(event, 'DAM')}
                  value={query}
                  autoFocus
                  //  onKeyPress={handleEnterKeypress}
                />
              </div>
            </div>
            <div className="uploadedImgScrollDams customScrollBar" style={{justifyContent:searchedResult?.length <1?'center':'', alignContent:searchedResult?.length <1?'center':''}}>
                {searchedResult?.map((loadImage, index) => (
                  <div className="row imageRow">
                    <div className="col-md-12">
                      <div className="thumbnail-image-content">
                        <img
                          src={loadImage?.imageProductionLink}
                          alt=""
                          draggable="false"
                          className={`gjs-imagetest${Math.random()} img-fluid dams-thumbnail-image`}
                          onClick={() => sendImage(loadImage, 'click')}
                        ></img>
                      </div>
                      <div 
                        className={`image-tab-imageDetails`}>
                      <div className={`imageNameCss ${Object.keys(loadImage.imageName).length > 21 
                          ? 'image-tab-imageDetails-tooltip' 
                          : ''}`}
                        data-title={Object.keys(loadImage.imageName).length > 21 ? loadImage.imageName: ""}
                      > {loadImage.imageName}</div> 
                       <div className="preview-image-thumbnail" onClick={() => openPreviewImageTab(loadImage)}>view</div>
                      </div>
                    </div>
                  </div>
                ))}
                {
                   loadedImages?.damsList?.length > 0 
                     ?  searchedResult?.length > 0 ? "" : 
                         <div className="not-found-message">
                           <img src={InfoIcon} width={7} height={8}/>
                           <p>No match found. Please try again.</p>
                         </div> 
                     : <div className="not-found-message">
                         <img src={InfoIcon} width={7} height={8}/>
                         <p>Please add images.</p>
                       </div>
	                 }
              </div>
            
          </Tab> */}
          
          <Tab
            eventKey="tab-3"
            className="iamgeTabs customScrollBar"
            title={`Links`}
            // title={`Links (${imageURL.length})`}
          >
            <div className="image-link-tab">
              <div className="image-url-search">
                <div className="urlIp">
                  <label className="image-url-label">
                    Image URL
                  </label>
                  <div className="add-image-url">
                    <input
                      value={linkUrl}
                      type="text"
                      className="image-url-field"
                      placeholder="Copy & paste or type here"
                      onChange={handleChangeURL}
                    />
                    <button disabled={linkUrl.length < 1} className="submit-image-url" onClick={submitImageURL}>
                      ADD
                    </button>
                  </div>
                </div>
                {/* <div className="d-flex local-image-search">
                  <img
                    alt="search"
                    src={LibrarySearchIcon}
                    className="local-image-search-icon"
                  />
                   <input 
                    type="text"
                    name="searchInput"
                    placeholder="Search by name"
                    className="local-image-search-field"
                    // onChange={(e) => handleChangesearchfields(e, "searchInput")}
                    autoComplete="off"
                    // onKeyDown={handleOnEnter}
                    onChange={handleChangeURL}
                    // value={query}
                    autoFocus
                    //  onKeyPress={handleEnterKeypress}
                  /> 
                </div> */}
              </div>
            </div>
            <div id="Link-imageList " className="customScrollBar uploadedImgScrollLink">
              {imageURL.map((imageurl) => (
                <div className="row imageRow">
                  <div className="col-md-12">
                    <img
                      id="iivw"
                      data-gjs-type="image"
                      alt={"bge"}
                      draggable="true"
                      onClick={() => sendImage(imageurl, 'click')}
                      src={imageurl}
                      class="gjs-selected link-thumbnail-image"
                      onDragStart={(event) => sendImage(imageurl, 'drag', event)}
                      style={{cursor: 'all-scroll'}}
                    ></img>
                  </div>
                  <div className="row d-none">
                    <div className="col-md-6 imageDetails">{imageURL.imageName}</div>
                    <div className="col-md-6 imageDetails">2498-7-22</div>
                  </div>
                </div>
              ))}
              {
                 imageURL?.length > 0 
                 ?  ""
                 : <div className="not-found-message">
                     <img src={InfoIcon} width={7} height={8}/>
                     <p>Please add image links.</p>
                   </div>
                // imageURL?.length > 0 
                //   ?  localResults?.length > 0 ? "" : 
                //       <div className="not-found-message">
                //         <img src={InfoIcon} width={7} height={8}/>
                //         <p>No match found. Please try again.</p>
                //         </div> 
                //   : <div className="not-found-message">
                //       <img src={InfoIcon} width={7} height={8}/>
                //       <p>Please add image links.</p>
                //     </div>
              } 
            </div>
          </Tab>
          <Tab
            className="uploadedSharedImage customScrollBar"
            eventKey="tab-4"
            title="Shared"
          >
            <div>
              <div className="image-local-tab">
                <div className="d-flex local-image-search">
                  <img
                    alt="search"
                    src={LibrarySearchIcon}
                    className="local-image-search-icon"
                  />
                  <input 
                    type="text"
                    name="searchInput"
                    placeholder="Search by name"
                    className="local-image-search-field"
                    autoComplete="off"
                    onChange={(event)=> setSharedImageInputValue(event.target.value.split(" ").join(""))}
                    value={sharedImageInputValue}
                    autoFocus
                  />
                </div>
              </div>
              <div className="uploadedSharedImgScroll customScrollBar" style={{justifyContent:localResults?.length < 1?'center':''}}>
                {/* {isloading && (
                  <CircularProgressBar
                  isloading={isloading}
                  setIsloading={setIsloading}
                  />
                )} */}
                {sharedSearchedResult?.map((loadImage, index) => (
                  <div className="row imageRow" key={index}>
                    <div className="col-md-12">
                      <div className="thumbnail-image-content">
                        <img
                          src={loadImage?.link}
                          alt=""
                          draggable="true"
                          className={`gjs-imagetest${Math.random()} img-fluid local-thumbnail-image`}
                          onClick={() => sendImage(loadImage?.link, 'click')}
                          onDragStart={(event) => sendImage(loadImage?.link, 'drag', event)}
                          style={{cursor: 'all-scroll'}}
                        ></img> 
                      </div>
                      <div className={`image-tab-imageDetails`}>
                        <div 
                          className={`imageNameCss ${Object.keys(localTabDetails(loadImage?.name)).length > 21 ? 
                          'image-tab-imageDetails-tooltip' : ''}`}
                          data-title={Object.keys(localTabDetails(loadImage.name)).length > 21 ? 
                            localTabDetails(loadImage.name): ""}
                          > {localTabDetails(loadImage.name)}</div> 
                          <div className="preview-image-thumbnail">
                            <p onClick={() => openPreviewImageTab(loadImage?.link)} className="preview-shared-image">View</p>
                            <img src={DeleteIcon} alt="" onClick={() => openDeleteSharedImage(loadImage)} className="uploaded-shared-delete-images"/>
                          </div>
                      </div>
                    </div>
                  </div>
                ))}
                {
                  appData?.deckId?.deck_shared_assets?.images?.length > 0 
                    ?  sharedSearchedResult?.length > 0 ? "" : 
                        <div className="not-found-message">
                          <img src={InfoIcon} width={8} height={8}/>
                          <p>No match found. Please try again.</p>
                        </div> 
                    : <div className="not-found-message">
                        <img src={InfoIcon} width={8} height={8}/>
                        <p>Please add images.</p>
                      </div>
                } 
            </div>
            </div>
          </Tab>
        </Tabs>
      </div>

      {showDAMSModel && (
        <CustomModal
          displayModal={showDAMSModel}
          hideModal={() => setShowDAMSModel(false)}
          title={""}
          size="xl"
          dilogClassName=""
          keyboard={false}
          appData={appData}
          showApprovedModal={setShowDAMSModel}
        >
          <DAMSSearchModal
            setShowDAMSModel={setShowDAMSModel}
            deckData={props.deckData}
            brands={props.brands}
            market={props.market}
            campaign={props.campaign}
            setLoadedImages={setLoadedImages}
            loadedImages={loadedImages}
          />
        </CustomModal>
      )}

      {isModalOpen && (<PreviewImageTab modalData={modalData} show={isModalOpen} setIsModalOpen={setIsModalOpen}/>)}
      {isDeleteModalOpen && (<DeleteImageModal show={isDeleteModalOpen} deleteSharedImage={deleteSharedImage}/>)}
    </div>
  );
}

export default MediaTab;